import React, { useState, useEffect } from "react";
import { pen } from "../../assets/images/index";
import { RouterConstant } from "../../routers/index";
import ChatFooter from "../../components/chat-footer";
import Carousel from "../../components/carousel";
import Button from "../../components/button";
import { useNavigate } from "react-router-dom";
import { useLayoutContext } from "../../layouts/general-layout";
import "./choose-exercise-with-history.scss";
import { TrackingService } from  "../../services/tracking/tracking.service";
import { useUserStore } from "../../utils/userStore";
import { resetExericeStore } from "../../utils/utils";
import { ExerciseQuestionsService } from "../../services/exercise-questions/exercise-questions.service";

interface Message {
    text: string;
    isBot: boolean;
    timestamp: Date;
}

export interface ExerciseHistoryResponseItem {
    exercise_id: number;
    topic: string;
    last_modified?: string;
    is_completed: boolean;
}

export default function Index() {
    const { t } = useLayoutContext();
    const navigate = useNavigate();
    const { ROUTERS_PATH } = RouterConstant;
    const [inputMessage, setInputMessage] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [sessionId, setSessionId] = useState("");
    const [loading, setLoading] = useState(true);
    const [exerciseHistory, setExerciseHistory] = useState<ExerciseHistoryResponseItem[]>([]);
    const trackingServiceInstance = new TrackingService();
    const trackingQuestionService = new ExerciseQuestionsService();
    const { justLoggedIn, setJustLoggedIn } = useUserStore();
    
    useEffect(() => {
        resetExericeStore();
        setSessionId(Date.now().toString(36) + Math.random().toString(36).substr(2));  

        if (justLoggedIn) {
            trackingServiceInstance.trackEvent("user_logged_in", { source: "login" });
            setJustLoggedIn(false);
        }
    }, []);
  
    useEffect(() => {
        fetchData();
    }, [navigate]);

    const fetchData = async () => {
        setLoading(true);
        try {
            const res = await trackingQuestionService.getExerciseHistory();
            if (res?.exercises?.length) {
                setExerciseHistory(res.exercises);
            }
        } catch (err) {
            console.error("Error fetching exercise history:", err);
        } finally {
            setLoading(false);
        }
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        navigate(ROUTERS_PATH.CHAT, { 
        state: {
            api: "TalkWithChat",
            payload: {message: inputMessage},
            from: "choose-exercise"
        }
        });
    };

    const handleKeyDown = (e: React.KeyboardEvent<HTMLFormElement>) => {
        if (e.key === "Enter" && e.shiftKey) {
        e.preventDefault();
        setInputMessage((prev) => prev + "\n");
        }
    };

    const handleCaptureExercise = () => {
        navigate(`${ROUTERS_PATH.CAPTUREEXERCISE}?sessionId=${sessionId}`);
    };

    return (
        <div className="full-head-template new-exercise choose-exercise-page custom-loader">
            <div className="new-exercis-header">
                <h4 className="new-exercis-title">{t("studyMathTogether")}!<span> {t("explainSlowlyUnderstandQuickly")}...</span></h4>
                <img src={pen} alt="Pen Icon" />
            </div>
            <div className="exercise-title">
                <h4>{t("recentExercises")}</h4>    
            </div>
        <Carousel items={exerciseHistory} />
        <div className="buttons-group">
            <Button text={t("card1ButtonText")} color="blue" onClick={handleCaptureExercise}/>
            <Button text={t("card2ButtonText")} color="green" onClick={() => navigate(ROUTERS_PATH.SEARCHEXRCISE)}/>
            <Button text={t("card3ButtonText")} color="purple" onClick={() => navigate(ROUTERS_PATH.SELFTESTSTART)}/> 
            {/*<Button text={t("card3ButtonText")} color="purple" onClick={() => navigate(ROUTERS_PATH.SEARCHBYBOOK)}/>*/}
        </div>
        <ChatFooter
            inputMessage={inputMessage}
            setInputMessage={setInputMessage}
            handleSubmit={handleSubmit}
            handleKeyDown={handleKeyDown}
            isLoading={isLoading}
            placeholderText={t("chatInputPlaceHolder")}
            isSendDisabled={inputMessage.trim().length < 10}
        />
        </div>
    );
}